// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1Hb7M","ranges":"BmiRanges_ranges__2Sr7v"};